import React from 'react'
import Text from '@component/Text/Text'

export const PointTermKorean = () => {
    return (
        <>
            <div className={'layout-desktop default_page_padding text-body2 text-gray02 dark:text-dark_gray02'}>
                <Text>제정일 : 2024.06.03</Text>
                <Text className={'mt-[10px]'}>시행일 : 2024.06.03</Text>
                <Text className={'text-ti1  mt-[20px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제 1조 (목적)
                </Text>
                <Text className={'mt-[10px]'}>
                    이 기준은 리그오브트레이더스(이하 &quot;서비스&quot; 라 함) 또는 리그오브트레이더스의 제휴사(이하
                    &quot;제휴사&quot;라 함)가 제공하는 각종 포인트의 이용, 환급, 소멸 등에 관한 제반사항을 정함을
                    목적으로 합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제 2 조 (용어의 정의)
                </Text>
                <Text className={'mt-[10px]'}>이 기준에서 사용하는 용어의 정의는 다음과 같습니다.</Text>
                <Text className={'mt-[10px]'}>
                    ① 포인트 라 함은 리그오브트레이더스에 계정을 생성하고 가입한 회원(이하 &quot;회원&quot;이라 함)이
                    &quot;서비스&quot;와 &quot;제휴사&quot;에서 적립, 사용할 수 있는 가치로서, 그 종류는 다음에서 정한
                    바에 따르기로 합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    가. &quot;포인트&quot;라 함은 &quot;회원&quot;이 서비스에서 &quot;서비스&quot; 내 기능을 통하여
                    혜택으로서 적립 받는 경우 등을 통하여 생성 또는 전송되는 가치를 말합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ② 이 기준에서 별도로 정하지 아니한 용어는 &quot;서비스&quot;의 이용약관에서 정하는 바에 따르기로
                    합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제3조 (적용대상)
                </Text>
                <Text className={'mt-[10px]'}>
                    이 기준은 리그오브트레이더스 &quot;서비스&quot;를 통하여 계정을 등록하고 가입한 &quot;회원&quot;에
                    적용됩니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제4조 (포인트의 적립)
                </Text>
                <Text className={'mt-[10px]'}>
                    &quot;회원&quot;은 &quot;서비스&quot; 내 기능의 사용에 따라서 일정 포인트를 적립받을 수 있습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 현재 &quot;서비스&quot; 내 &quot;챌린지&quot; 기능에 대하여 &quot;회원&quot;의 사용으로
                    &quot;서비스&quot; 내에 지불된 포인트의 70%를 적립받을 수 있습니다. 이 경우, &quot;챌린지&quot;
                    기능의 완료에 대하여 72시간 후 적립이 실행되며, 환급신청된 포인트 등은 적립 대상에서 제외합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ② 제1항에서 정하지 아니한 &quot;포인트&quot;의 적립는 &quot;서비스&quot;의 홈페이지 또는 모바일
                    어플리케이션 등을 통해 확인하실 수 있습니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제5조 (포인트의 이용방법)
                </Text>
                <Text className={'mt-[10px]'}>이 기준에서 사용하는 용어의 정의는 다음과 같습니다.</Text>
                <Text className={'mt-[10px]'}>
                    ① &quot;포인트&quot;의 종류별 이용방법은 다음 각 호에서 정한 바에 따르기로 합니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'mt-[10px]'}>
                        1. 포인트는 &quot;서비스&quot; 내의 기능 중 &quot;교환&quot;의 유료 기능 활성화에 사용할 수
                        있습니다.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        2. 포인트는 &quot;서비스&quot; 내의 기능 중 &quot;구독&quot;의 유료 기능 활성화에 사용할 수
                        있습니다.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    ② 제1항에서 정한 &quot;포인트&quot;의 사용처는 &quot;서비스&quot;의 홈페이지 또는 모바일
                    어플리케이션 등에서 확인하실 수 있습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ③ 적립된 &quot;포인트&quot;의 사용에 따른 차감의 순위는 적립된 일자 순서에 의합니다. 다만,
                    &quot;서비스&quot;가 달리 정하여 안내한 경우에는 그에 따르기로 합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제6조 (포인트의 교환)
                </Text>
                <Text className={'mt-[10px]'}>&quot;회원&quot;은 &quot;서비스&quot; 내에서 적립받은 포인트</Text>
                <Text className={'mt-[10px]'}>
                    ① 적립받은 포인트는 &quot;서비스&quot; 내에서 쿠폰 또는 토큰 등의 상품으로 환급할 수 있습니다.
                    환급이 가능한 상품은 별도 페이지를 통해 고지합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제7조 (포인트의 이용제한 등)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① &quot;포인트&quot; 는 대여양도 대상이 되지 않으며 다른 종류의 포인트와 호환ㆍ합산되지 않습니다.
                    다만, &quot;서비스&quot;가 달리 정하여 서비스의 홈페이지 또는 모바일 어플리케이션 등을 통해 안내한
                    경우에는 그 안내된 내용에 따르기로 합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제8조 (&quot;포인트&quot;의 소멸)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① &quot;포인트&quot; 는 다음 각 호에서 정한 유효기한 내에서 사용할 수 있으며 유효기한이 경과된
                    포인트는 월단위로 자동 소멸됩니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text>
                        &quot;포인트&quot;의 유효기한은 적립일로부터 2년이며, 회원이 탈퇴할 경우 탈퇴 즉시 소멸될 수
                        있습니다.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    ② 제1항에도 불구하고 &quot;회원&quot;이 다음 각 호의 1에 해당하는 경우 적립된 &quot;포인트&quot;는
                    자동으로 소멸됩니다. 다만, 제 1호 내지 제 3호의 경우에는 그로 인하여 적립된 &quot;포인트&quot;만을
                    대상으로 합니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'mt-[10px]'}>1. 입회신청서의 허위기재, 사위 등의 방법으로 부정 발급된 경우</Text>
                    <Text className={'mt-[10px]'}>
                        2. 물품구매를 위장한 불건전한 용도로 &quot;서비스&quot;를 이용한 경우
                    </Text>
                    <Text className={'mt-[10px]'}>
                        3. 도난, 위ㆍ변조 등의 방법으로 &quot;서비스&quot;를 이용한 경우
                    </Text>
                    <Text className={'mt-[10px]'}>
                        4. 법률 또는 &quot;회원&quot;의 요청으로 &quot;회원&quot;의 정보가 삭제되는 경우
                    </Text>
                    <Text className={'mt-[10px]'}>
                        5. 기타 &quot;서비스&quot;의 에러나 비일반적인 상황을 악용한 경우
                    </Text>
                </div>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제9조 (기준의 변경)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① 이 약관을 변경할 경우, 약관에 대한 변경 내용을 홈페이지 또는 모바일 어플케이션에 고지합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ② 전항의 경우 회원이 통지일로부터 1개월이내 별도 회원 탈퇴 의사표시를 하지 않는 경우 변경에
                    동의한다는 것으로 보는 내용을 명시하여 통지 합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    ③ 회원이 변경예정일까지 이의를 제기 하지 않았을 때는 변경된 약관을 승인한 것으로 간주 합니다.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    제10조 (준용규정)
                </Text>
                <Text className={'mt-[10px]'}>
                    이 기준에서 정하지 아니한 사항은 관련 법령, 회원 표준약관 및 상관례에 따릅니다.
                </Text>
            </div>
        </>
    )
}
